import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VoyagersClubMainContainerProps } from '@msc-b2c/interfaces/types';
import {
  getActiveSession,
  GetVoyagerClubInfoMyMSC,
  membershipsData,
  membershipDataIsLoading,
  closeLoader,
  openLoader,
  RootState,
} from '@msc-b2c/shared-utils';
import { RetrieveVoyagerClubInfoMyMSCResponse } from '@msc-b2c/interfaces/interfaces';
import styles from './voyagersclubmaincontainer.module.scss';

export function VoyagersClubMainContainer({ children }: Readonly<VoyagersClubMainContainerProps>) {
  const dispatch = useDispatch();
  const { email } = getActiveSession();
  const cachedMembershipData = useSelector((state: RootState) => state.myCruise.membershipData);

  const removeCartSkeleton = () => {
    const cartSkeleton = document.querySelector('.voyagers-club-skeleton');
    if (cartSkeleton) cartSkeleton.remove();
  };

  useEffect(() => {
    // Reuse membership data already in Redux (e.g. fetched by PlanMyCruiseContainerWrapper
    // or after a booking switch). This avoids a redundant API call on every mount.
    // AlreadyMemberLayout.refetchMembershipData() is user-triggered and bypasses this guard.
    if (cachedMembershipData) {
      dispatch(membershipDataIsLoading(false));
      removeCartSkeleton();
      return;
    }

    dispatch(membershipDataIsLoading(true));
    const fetchVoyagerClubInfo = async () => {
      openLoader('.loader');
      try {
        // Use mock=true to avoid JWT/network issues during development
        const voyagerClubInfoAPI = new GetVoyagerClubInfoMyMSC(false, {
          email: email || '',
        });
        const data: RetrieveVoyagerClubInfoMyMSCResponse = await voyagerClubInfoAPI.getData();

        if (data?.memberships) {
          dispatch(membershipsData(data));
        }
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : 'Failed to fetch voyager club info';
        console.error(errorMessage);
      } finally {
        dispatch(membershipDataIsLoading(false));
        closeLoader('.loader');
        removeCartSkeleton();
      }
    };
    fetchVoyagerClubInfo();
  }, [email, cachedMembershipData]);

  return <div className={styles['cmp-voyagers-club-main-container']}>{children}</div>;
}

export default VoyagersClubMainContainer;
